import React from 'react';
import { STUDIO_TABS } from '../../utils/studioTabs';
import './ProjectTabs.css';

const LABELS = {
    overview: 'Overview',
    footage: 'Footage',
    edits: 'Edits',
};

const ProjectTabs = ({ activeTab, onChange }) => {
    return (
        <div className="project-tabs" role="tablist">
            {STUDIO_TABS.map((tab) => {
                const isActive = tab === activeTab;
                return (
                    <button
                        key={tab}
                        type="button"
                        role="tab"
                        aria-selected={isActive}
                        className={`project-tab${isActive ? ' project-tab--active' : ''}`}
                        onClick={() => onChange(tab)}
                    >
                        {LABELS[tab]}
                    </button>
                );
            })}
        </div>
    );
};

export default ProjectTabs;
